import { createStore } from 'vuex'
import { times } from '@/components/store/Data'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getCookieValue } from '@/components/util/cookies'
import auth from './modules/auth'
import users from './modules/users'
import cities from './modules/cities'
import roles from './modules/roles'
import schedules from './modules/schedules'
import services from './modules/services'
import clients from '@/components/store/modules/clients'
import appointments from '@/components/store/modules/appointments'
import custom_fields from '@/components/store/modules/custom_fields'
import certificates from '@/components/store/modules/certificates'
import abonements from '@/components/store/modules/abonements'
import payments from '@/components/store/modules/payments'
import socket from '@/components/store/modules/socket/socket'
import messengers from '@/components/store/modules/messengers'
import settings from '@/components/store/modules/settings'
import billing from '@/components/store/modules/billing'
import { reportApiFailure } from '@/services/monitoring'

const request = async (path, data = {}) => {
  data['cookie'] = getCookieValue('token')
  const url = 'https://lk.lineon.me/api/' + path

  try {
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    const raw = await result.text()
    let parsed = null
    try {
      parsed = raw ? JSON.parse(raw) : {}
    } catch {
      parsed = null
    }

    if (result.status >= 500) {
      reportApiFailure({
        url,
        method: 'POST',
        statusCode: result.status,
        message: parsed?.error?.message || parsed?.error || `api_${result.status}`,
        requestId: result.headers.get('x-request-id') || '',
        responseBody: raw,
      })
    }

    return parsed ?? { success: false, error: { code: 'invalid_json_response' } }
  } catch (error) {
    reportApiFailure({
      url,
      method: 'POST',
      statusCode: 0,
      message: error?.message || 'network_error',
    })
    return { success: false, error: { code: 'network_error' } }
  }
}

export default createStore({
  modules: { billing, auth, users, cities, roles, schedules, services, clients, appointments, custom_fields, certificates, abonements, payments, socket, messengers, settings },
  state: {
    times: times,
    dateViews: [],
    notes: [],
    contacts: [],
    doctors_calendar: [],
    access: {
      setting: false,
      add_notes: false,
      add_doctors: false,
      add_filial: false,
      add_service: false,
      cities: []
    },
    uploading: false,
    uploadProgress: 0,
    uploadEmployeeId: null
  },
  getters: {
    account_id: state => state.auth.user.account_id,
    user: state => state.auth.user,
    employees: state => state.users.employees,
    uploading: state => state.uploading,
    uploadProgress: state => state.uploadProgress,
    uploadEmployeeId: state => state.uploadEmployeeId,
    getCities: (state) => {
      return state.cities
    },
    allRoles: (state) => {

      console.log(state.roles.roles)

      return state.roles.roles
    }
  },
  actions: {
    registrationAdmin({ dispatch }, payload) {
      return dispatch('auth/registrationAdmin', payload)
    },
    async getServices({ commit }, data) {
      const res = await request('services.get', data)
      if (res?.list) {
        commit('SET_SERVICES', res?.list)
      }
    },
    async createService({ commit }, option) {
      option['account_id'] = this.state.account_id
      const res = await request('services.create', option)
      if (res?.list) {
        commit('SET_SERVICES', res?.list)
      }
    },
    async updateService({ commit }, option) {
      const res = await request('services.update', option)
      if (res?.list) {
        commit('SET_SERVICES', res?.list)
      }
    },
    async removeService({ commit }, option) {
      const res = await request('services.delete', option)
      if (res?.list) {
        commit('SET_SERVICES', res?.list)
      }
    },
    async searchContact({ commit }, option) {
      const res = await request('contact.search', option)
      if (res?.list) {
        commit('SET_CONTACTS', res?.list)
      }
    },
    async addContact({ commit }, data) {
      data['account_id'] = this.state.account_id
      commit('SET_CONTACTS', [])
      return await request('contact.add', data)
    },
    async getNotes({ commit }, data) {
      const res = await request('notes.get', data)
      if (res?.list) {
        commit('SET_NOTES', res?.list)
      }
    },
    async createNote({ commit }, option) {
      option['account_id'] = this.state.account_id
      const res = await request('notes.create', option)
      if (res?.list) {
        commit('SET_NOTES', res?.list)
      }
    },
    async updateNote({ commit }, option) {
      const res = await request('notes.update', option)
      if (res?.list) {
        commit('SET_NOTES', res?.list)
      }
    },
    async getCalendarData({ commit }, option) {
      const res = await request('calendar.data', option)
      if (res?.list) {
        commit('SET_NOTES', res?.list)
      }
    },
    async uploadAvatar({ commit }, { file, data }) {
      const token = getCookieValue('token')
      const formData = new FormData()
      formData.append('ava', file.file)
      formData.append('id', data.employeeId)
      try {
        commit('SET_UPLOADING', true)
        commit('SET_UPLOAD_PROGRESS', 0)
        commit('SET_UPLOAD_EMPLOYEE_ID', data.employeeId)

        const response = await axios.post('https://lk.lineon.me/api/upload.ava', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100)
            commit('SET_UPLOAD_PROGRESS', progress)
          }
        })
        if (response.status === 200) {
          if (response?.data?.list) {
            commit('users/setEmployees', response?.data?.list, { root: true })
          }
          if (response?.data?.user) {
            commit('auth/SET_USER', response.data.user, { root: true })
          }
          ElMessage.success('Аватар успешно загружен')
        } else {
          ElMessage.error('Ошибка при загрузке аватара')
        }

      } catch (error) {
        console.error('Ошибка загрузки:', error)
        ElMessage.error('Ошибка при загрузке аватара')
      } finally {
        commit('SET_UPLOADING', false)
        commit('SET_UPLOAD_PROGRESS', 0)
        commit('SET_UPLOAD_EMPLOYEE_ID', null)
      }
    },
    async getPositions({ state, commit }) {
      const data = {
        account_id: state.account_id
      }
      const res = await request('positions.get', data)
      if (res?.list) {
        commit('SET_POSITIONS', res?.list)
      }
    },
    async createPositions({ commit }, data) {
      data['account_id'] = this.state.account_id
      const res = await request('positions.create', data)
      if (res?.list) {
        commit('SET_POSITIONS', res?.list)
      }
    },
    async updatePositions({ commit }, data) {
      data['account_id'] = this.state.account_id
      const res = await request('positions.update', data)
      if (res?.list) {
        commit('SET_POSITIONS', res?.list)
      }
    },
    async deletePositions({ commit }, data) {
      data['account_id'] = this.state.account_id
      const res = await request('positions.delete', data)
      if (res?.list) {
        commit('SET_POSITIONS', res?.list)
      }
    },
    async fetchRoles({ commit }) {
      const data = { account_id: this.state.account_id }
      const res = await request('roles.get', data)
      commit('SET_ROLES', res.data)
    },
    async createRole({ commit }, payload) {
      payload['account_id'] = this.state.account_id
      const res = await request('roles.create', payload)
      commit('SET_ROLES', res.data)
    },
    async updateRole({ commit }, payload) {
      payload['account_id'] = this.state.account_id
      const res = await request('roles.update', payload)
      commit('SET_ROLES', res.data)
    },
    async deleteRole({ commit }, id) {
      const data = { account_id: this.state.account_id, id: id }
      const res = await request('roles.update', data)
      commit('SET_ROLES', res.data)
    }
  },
  mutations: {
    SET_TIMES(state, data) {
      state.times = data
    },
    SET_NOTES(state, data) {
      state.notes = data
    },
    SET_SCHEDULES(state, schedules) {
      state.schedules = schedules
    },
    SET_DOCTORS_CALENDAR(state, data) {
      state.doctors_calendar = data
    },
    SET_SERVICES(state, data) {
      state.services = data
    },
    SET_CONTACTS(state, data) {
      state.contacts = data
    },
    SET_UPLOADING(state, uploading) {
      state.uploading = uploading
    },
    SET_UPLOAD_PROGRESS(state, uploadProgress) {
      state.uploadProgress = uploadProgress
    },
    SET_UPLOAD_EMPLOYEE_ID(state, uploadEmployeeId) {
      state.uploadEmployeeId = uploadEmployeeId
    },
    SET_ACCOUNT_ID(state, account_id) {
      state.account_id = account_id
    }
  }
})
